/**
 *
 * Ask
 *
 */

export const QaContentModelMixin = {
  name: 'QaContentModelMixin',

  data: () => {
    return {
      qaContent: '',
    };
  },

  computed: {
    c_isQaContentBlank() {
      return '' === this.qaContent || '<p><br></p>' === this.qaContent;
    },
  },
};

export default QaContentModelMixin;
